import React from 'react';
import SubMenu from "../../../base/SubMenu";
import GGS from "./GGS";
import Schulleben from "./Schulleben";
import Info from "./Info";
import Downloads from "../../base/Downloads";
import Projekte from "./Projekte";
import styles from './IGSGrundstufe.module.css';
import igsgrundstufe from "../assets/grund.png";
import iconiks from "../assets/iconiks.png";

const IGSGrundstufeWelcome = (props) => {
    return (
        <React.Fragment>
          <>
                <div
                    className={styles.hero}
                    style={{ backgroundImage: `url(${igsgrundstufe})` }}
                >
                <div className={styles.welcomeCard}>
                    <h2 className={styles.heading}>IGS GRUNDSTUFE</h2>
                    <h2 className={styles.subHeading}>HERZLICH WILLKOMMEN</h2>
                    <p className={styles.paragraph}>
                        Wir freuen uns, dass Sie sich für unsere
                        <span className={styles.boldText}>  IKS – Interkulturelle Schule Rhein-Main </span>
                        interessieren.
                    </p>

                    <img src={iconiks} alt="Arrow Icon" className={styles.arrow} />

                </div>
                </div>

                </>
            <div className="wrapper wrapperContent">

                <div className={styles.textLeft}>
                    <h1>Respektvoll und offen. Wir lieben Vielfalt</h1>
                    <p>
                        Herzlich willkommen in unserer Grundschule für kulturelle und pädagogische Vielfalt! Wir verbinden und vereinen in unserer Schule theoretisches Lernen mit praktischem Tun, Handeln und Wissen als weiteren Schritt in die Zukunft. Interkulturelle Vielfalt ist unser durchgehendes Bildungsprinzip. Wir bezeichnen unsere Schule bewusst als „interkulturell“, da wir voneinander lernen, unser kulturelles Wissen erweitern und ein gemeinsames Miteinander pflegen. Unsere Schule orientiert sich am Lehrplan des Landes Hessens und achtet auf die individuelle Förderung jedes einzelnen Kindes.

                    </p>
                </div>
            </div>
            <div className={styles.sectionDiagonalRight}>
                <div className={styles.darkBackground + ' wrapper wrapperContent'}>
                    <h1>Fit für die Zukunft</h1>
                    <p>
                        Im Zeitalter der Globalisierung ist Mehrsprachigkeit von zentraler Bedeutung für die Zukunft der Kinder.                    </p>

                    <p> Gelebte kulturelle Vielfalt ist unser durchgehendes Bildungsprinzip.</p>
                </div>
            </div>

            <div className="wrapper wrapperContent">
                <div className={styles.textLeft}>
                    <h1>Vorsprung von Anfang an</h1>
                    <p>
                        Wir fördern die intensive Grundlagenbildung in Deutsch, Englisch, Mathematik und Sport sowie die Entwicklung zur Mehrsprachigkeit durch zielgerichtete Angebote.
                    </p>
                    <p>
                        Englisch wird bereits ab der ersten Klassen angeboten, weil wir so unserem Bildungsprinzip der kulturellen und sprachlichen Vielfalt näher kommen.
                    </p>
                </div>
            </div>

            <div className={styles.sectionDiagonalLeft}>
                <div className={styles.darkBackground + ' wrapper wrapperContent'}>
                    <h1>Individuell abgeschnitten </h1>
                    <p>
                        Individuelle Lernzeiten, Spiel, Spaß und Bewegung sind am Nachmittag angesagt.
                    </p>
                    <p>Berufstätige Eltern werden unser Angebot sehr schätzen: sowohl Früh- als auch Spätbetreuung ist möglich.</p>
                    <p>Selbstverständlich bieten wir auch Ferienbetreuung an.</p>
                </div>
            </div>

            <div className="wrapper wrapperContent">
                <div className={styles.listBlock}>

                    <h2>Unser Leitbild</h2>
                    <ul>
                        {[
                            "Ganzheitlicher Unterrichtsansatz",
                            "Verlässliche Grundschule",
                            "Lust und Spaß am Entdecken",
                            "Projektorientiertes und vernetztes Lernen",
                            "Individuelle Förderung",
                            "Erziehung zum selbstständigen Lernen",
                            "Interkulturelles Lernen"
                        ].map((item, index) => (
                            <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {item}
                            </li>
                        ))}
                    </ul>

                    <h2>Schwerpunkte</h2>
                    <ul>
                        {[
                            "Unterricht in kleinen Klassen",
                            "Früh- und Spätbetreuung",
                            "Englisch ab 1. Klasse / Cambridge English",
                            "Sport- und Schwimmunterricht ab 1. Klasse",
                            "Umfangreiches Fremdsprachenangebot",
                            "Musikalische Früherziehung/Instrumentenvielfalt",
                            "Intensive Kooperation von Schüler*innen sowie Lehrern und Eltern"
                        ].map((item, index) => (
                            <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {item}
                            </li>
                        ))}
                    </ul>

                </div>
            </div>
        </React.Fragment>
    );
};

const Main = (props) => {

    const ggsRef = React.createRef()
    const schulebeneRef = React.createRef()
    const downloadsRef = React.createRef()
    const infoRef = React.createRef()
    const projekteRef = React.createRef()


    return (
        <div>
            <SubMenu model={{
                background: "#d8f3dc",
                items: [
                    { label: <strong>IGS Grundstufe</strong>},
                    { label: "Start", onClick: () => window.location.href = "/bildungsangebote/igsgrundstufe"},
                    { label: "GGS", onClick: () =>  ggsRef.current.scrollIntoView()},
                    { label: "Schulebene", onClick: () => schulebeneRef.current.scrollIntoView()},
                    {label: "Info", onClick: ()=>infoRef.current.scrollIntoView() },
                    {label: "Projekte", onClick: ()=>projekteRef.current.scrollIntoView()},
                    { label: "Downloads", onClick: () => downloadsRef.current.scrollIntoView()}

                ]
            }}/>


            <IGSGrundstufeWelcome />
            <div ref={ggsRef} style={{paddingTop: 'calc(var(--header-height))'}}><GGS/></div>
            <div ref={schulebeneRef} style={{paddingTop: 'calc(var(--header-height))'}}><Schulleben/></div>
            <div ref={infoRef} style={{paddingTop: 'calc(var(--header-height))'}}><Info/></div>
            <div ref={projekteRef} style={{paddingTop: 'calc(var(--header-height))'}}><Projekte/></div>
            <div ref={downloadsRef} className="wrapper wrapperContent" style={{paddingTop: 'calc(var(--header-height))', color:"#488e62"}}>

                <Downloads
                    model={
                        {
                            items: [
                                {label: 'Anmeldeformular', download: 'anmeldeformular.pdf', url: '/assets/igsgrundstufe/Schulvertrag_IGSGS_GS_mai25.pdf'}
                             /*   {label: 'Kopflausbefall ???', url: ''},
                                {label: 'Beurlaubung ???', url: ''},
                                {label: 'Lehrplan ???', url: ''}*/
                            ]
                    }
                }/>
            </div>
        </div>
    );
};

export default Main;
